// INTEL CONFIDENTIAL
// Copyright (C) 2023 Intel Corporation
import './src/pages/index.scss'
export const onClientEntry = (): void => {
  const script = document.createElement('script')
  script.src = '/setupConfigMap.js'
  document.body.appendChild(script)

  script.onload = () => {
    if (window.loadConfig) {
      window.loadConfig()
    }
  }
}
